module.exports = __webpack_public_path__ + "static/media/mraBlog4.788b7c77.jpg";